<template>
  <div class="index">
    <el-row>
      <el-col :span="18" :offset="3">
        <h3 class="buy-title">
          我的余额
          <!-- <span class="title-contact">
              服务咨询，请致电
              <span style="color:#3BC492">18971608045</span>
            </span> -->
        </h3>
        <info :balance="balance"></info>
        <recharge title="充值中心"></recharge>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import info from "../components/info";
import recharge from "../components/recharge";
import chosePay from "../components/chosePay";
import Cookie from "js-cookie";
import { customerBalance } from "@/api/setUp.js";
export default {
  name: "index",
  components: {
    info,
    recharge,
    chosePay,
  },
  data() {
    return {
      userInfo: "",
      balance: 0,
    };
  },
  methods: {},
  async mounted() {
    let { data } = await customerBalance();
    this.balance = data;
  },
};
</script>

<style lang="less" scoped>
.index {
  padding: 42px 0;
}
.title-contact {
  font-size: 16px;
  float: right;
  line-height: 30px;
}
</style>
